import { render, staticRenderFns } from "./TheSnapshotDistributions.vue?vue&type=template&id=b5088baa&"
import script from "./TheSnapshotDistributions.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotDistributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports